import {tokenReceived} from "../redux/slices/authenticationSlice";
import {useDispatch} from "react-redux";
import {useLazyCurrentCompanyQuery, useSwitchCompanyMutation} from "../apis/companiesApi";
import {useLazyUserProfileQuery, useRecreateRefreshTokenMutation} from "../apis/authenticationApi";
import {useMemo} from "react";
import {useLazyListKpiTargetsQuery} from "../apis/kpiApi";
import {useNavigate} from "react-router-dom";

export const useCompany = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [switchCompany] = useSwitchCompanyMutation();
    const [triggerUserProfile] = useLazyUserProfileQuery();
    const [triggerCurrentCompany] = useLazyCurrentCompanyQuery();
    const [triggerKpiTargets] = useLazyListKpiTargetsQuery();
    const [recreateRefreshToken] = useRecreateRefreshTokenMutation();

    return useMemo(() => async company => {
        const results = await switchCompany(company);
        if (results?.data?.message) {
            dispatch(tokenReceived(results.data.message));
            triggerUserProfile();
            triggerCurrentCompany();
            triggerKpiTargets();
            await recreateRefreshToken();
            navigate('/');
        }
    }, [dispatch, recreateRefreshToken, triggerUserProfile, triggerCurrentCompany, triggerKpiTargets, switchCompany]);

}
